<template>
  <div>
    <div class="contents swings">
      <b-form @submit="onSubmit">
        <div class="date-search">
          <input
            type="date"
            class="form-control-lg"
            v-model="searchData.startdate"
          />
          <input
            type="date"
            class="form-control-lg"
            v-model="searchData.enddate"
          />
          <input class="btn btn-primary btn-lg search" type="submit" value="" />
        </div>
      </b-form>
      <table class="table board" id="dataTable">
        <thead>
          <tr>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.swing.swing_video") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.title") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.nickname") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <th class="col-auto d-lg-table-cell">
              {{ $t("title.common.favorite_location") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.status") }}
            </th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.control") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="dataYn">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-none d-lg-table-cell">{{ item.no }}</td>
              <td class="col-auto d-none d-lg-table-cell">
                <router-link
                  :to="{
                    name: 'SwingView',
                    params: { id: item.swingno },
                    query: searchData,
                  }"
                  class="text-center d-block position-relative"
                >
                  <img src="/img/ico_mov.png" class="mov_icon" />
                  <img
                    src="/img/video_img.png"
                    class="w-auto h-50px mb-0"
                    v-if="browser === 'safari'"
                  />
                  <video
                    :src="item.path + '/' + item.swingmovie"
                    class="w-auto h-50px mb-0"
                    v-else
                  ></video>
                </router-link>
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                <router-link
                  :to="{
                    name: 'SwingView',
                    params: { id: item.swingno },
                    query: searchData,
                  }"
                  class="text-center d-block position-relative"
                >
                  <div class="fill-white">
                    {{ item.title || "" }}

                    <span class="color-9b9fa3" v-if="item.replycnt > 0">
                      <i class="material-icons">textsms</i>
                      {{ item.replycnt | comma }}
                    </span>
                  </div>
                </router-link>
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                <MemberInfo
                  :nickname="item.nickname"
                  :playerno="item.playerno"
                  :displayText="item.nickname"
                />
              </td>
              <td class="col-auto d-none d-lg-table-cell">{{ item.date }}</td>
              <td class="col-auto d-lg-table-cell">{{ item.shopname }}</td>
              <td class="col-auto d-none d-lg-table-cell">
                {{
                  item.flag == "0"
                    ? $t("filter.swing.public")
                    : $t("filter.swing.private")
                }}
              </td>
              <td class="col-auto d-none d-lg-table-cell">
                <button
                  type="button"
                  class="btn btn-outline btn-xs pr-4 pl-4"
                  @click="
                    //$refs['settingModal'].modalOuterStyle.zIndex = 9999;
                    $refs['settingModal'].show();
                    sendData.swingno = item.swingno;
                    sendData.title = item.title;
                    sendData.content = item.content;
                    sendData.flag = item.flag;
                  "
                >
                  {{ $t("button.common.edit") }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-xs pr-4 pl-4"
                  @click="deleteSwing(item.swingno)"
                >
                  {{ $t("button.common.delete") }}
                </button>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img src="/img/arrow_none_collapsed.png" />
              </td>
            </tr>
            <tr
              class="col-auto d-lg-none d-md-tabel-cell"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td class="text-start" colspan="7">
                <router-link
                  :to="{
                    name: 'SwingView',
                    params: { id: item.swingno },
                    query: searchData,
                  }"
                  class="btn_view"
                >
                  <img src="/img/ico_edit.png" />
                </router-link>
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.number") }}</div>
                    <div class="col-6">{{ item.no }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.swing.swing_video") }}</div>
                    <div class="col-6">
                      <router-link
                        :to="{
                          name: 'SwingView',
                          params: { id: item.swingno },
                          query: searchData,
                        }"
                        class="d-block position-relative"
                      >
                        <img src="/img/ico_mov.png" class="mov_icon" />
                        <img
                          src="/img/video_img.png"
                          class="d-block mw-100 mb-0"
                          v-if="browser === 'safari'"
                        />
                        <video
                          :src="item.path + '/' + item.swingmovie"
                          class="d-block mw-100 mb-0"
                          v-else
                        ></video>
                      </router-link>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.title") }}</div>
                    <div class="col-6">
                      <router-link
                        :to="{
                          name: 'SwingView',
                          params: { id: item.swingno },
                          query: searchData,
                        }"
                        class="d-block position-relative"
                      >
                        {{ item.title }}
                      </router-link>
                      {{ item.replycnt }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.nickname") }}</div>
                    <div class="col-6">
                      <MemberInfo
                        :nickname="item.nickname"
                        :playerno="item.playerno"
                        :displayText="item.nickname"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.date") }}</div>
                    <div class="col-6">{{ item.date }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.status") }}</div>
                    <div class="col-6">
                      {{ item.flag == "0" ? "Private" : "Public" }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.control") }}</div>
                    <div class="col-6">
                      <button
                        type="button"
                        class="btn btn-outline btn-xs pr-4 pl-4"
                        @click="
                          //$refs['settingModal'].modalOuterStyle.zIndex = 9999;
                          $refs['settingModal'].show();
                          sendData.swingno = item.swingno;
                          sendData.title = item.title;
                          sendData.content = item.content;
                          sendData.flag = item.flag;
                        "
                      >
                        {{ $t("button.common.edit") }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary btn-xs pr-4 pl-4"
                        @click="deleteSwing(item.swingno)"
                      >
                        {{ $t("button.common.delete") }}
                      </button>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8" class="text-center">{{ $t("text.common.no_data") }}</td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="pageTotal"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="pageTotal > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
    </div>
    <b-modal
      id="settingModal"
      ref="settingModal"
      size="lg"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header>
        <h5 class="modal-title">
          {{ $t("page.swing.swing_title_edit") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="$refs['settingModal'].hide()"
        ></b-button>
      </template>
      <div class="row border-bottom border-top">
        <div
          class="col-lg-3 bg-light row align-items-center"
          style="padding: 10px"
        >
          <label class="d-table-cell">{{ $t("title.common.title") }}</label>
        </div>
        <div class="col-lg" style="padding: 10px 20px">
          <input type="text" class="form-control-lg" v-model="sendData.title" />
        </div>
      </div>
      <div class="row border-bottom">
        <div
          class="col-lg-3 bg-light row align-items-center"
          style="padding: 10px"
        >
          <label class="d-table-cell">{{ $t("title.swing.content") }}</label>
        </div>
        <div class="col-lg" style="padding: 10px 20px">
          <input
            type="text"
            class="form-control-lg"
            v-model="sendData.content"
          />
        </div>
      </div>
      <div class="row border-bottom">
        <div
          class="col-lg-3 bg-light row align-items-center"
          style="padding: 10px"
        >
          <label class="d-table-cell">{{ $t("title.common.status") }}</label>
        </div>
        <div class="col-lg" style="padding: 10px 20px">
          <div class="form-check d-inline-block me-3" style="margin-right: 5px">
            <input
              class="form-check-input"
              type="radio"
              id="Private"
              value="0"
              v-model="sendData.flag"
              :checked="sendData.flag == '0'"
            />
            <label class="form-check-label" for="Private">{{
              $t("title.swing.private")
            }}</label>
          </div>
          <div class="form-check d-inline-block">
            <input
              class="form-check-input"
              type="radio"
              id="Public"
              value="1"
              v-model="sendData.flag"
              :checked="sendData.flag == '1'"
            />
            <label class="form-check-label" for="Public">{{
              $t("title.swing.public")
            }}</label>
          </div>
        </div>
      </div>
      <template #modal-footer="{}">
	      <b-button
          size="md"
          variant="outline-secondary"
          :aria-label="$t('button.common.cancel')"
          @click="$bvModal.hide('settingModal')"
        >
          {{ $t("button.common.cancel") }}
        </b-button>
        <b-button
          size="md"
          variant="secondary"
          :aria-label="$t('button.common.apply')"
	        @click="confirm"
        >
          {{ $t("button.common.apply") }}
        </b-button>
</template>
    </b-modal>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/swing";

export default {
  name: "SwingList",
  data() {
    return {
      searchData: {
        startdate:
          this.$route.query.startdate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].startdate) ||
          this.$dayjs().add(-1, "month").format("YYYY-MM-DD"),
        enddate:
          this.$route.query.enddate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].enddate) ||
          this.$dayjs().format("YYYY-MM-DD"),
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
      },

      sendData: {
        swingno: 0,
        content: "",
        title: "",
        flag: 0,
      },
      pageTotal: 1,
      totalCnt: 0,
      dataYn: true,
      rows: 10,
      items: [],
      view_hide: null,
      browser: "",
    };
  },
  watch: {
    "searchData.startdate": function () {
      this.searchData.pageno = 1;
      this.getList();
    },
    "searchData.enddate": function () {
      this.searchData.pageno = 1;
      this.getList();
    },

    "searchData.pageno": function () {
      this.getList();
    },
  },

  created() {
    this.getList();
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      this.getList();
    },
    getList() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.getList(this.searchData, (flag, data) => {
        if (flag) {
          if (data.swinglistcnt <= 0) {
            this.dataYn = false;
          } else {
            this.dataYn = true;
          }
          this.totalCnt = data.swinglistcnt;
          this.pageTotal = Math.ceil(data.swinglistcnt / this.rows);
          this.items = data.swinglist;
        } else {
          this.dataYn = false;
          this.pageTotal = 0;
          if (data.code !== 300) alert(data.message);
        }
      });
    },
    goView(idx) {
      let no = this.items[idx].swingno;
      this.$router.push({
        name: "SwingView",
        params: { id: no },
        query: {
          pageno: this.$route.query.pageno || 1,
          startdate: this.searchData.startdate,
          enddate: this.searchData.enddate,
        },
      });
    },
    flagChange(flag, swingno) {
      ax.changeFlag(flag, swingno, (flag, data) => {
        if (flag) {
          this.getList();
        } else {
          this.dataYn = false;
          this.pageTotal = 0;
          alert(data);
        }
      });
    },
    deleteSwing(swingno) {
      ax.deleteSwing(swingno, (flag, data) => {
        if (flag) {
          this.getList();
        } else {
          this.dataYn = false;
          this.pageTotal = 0;
          alert(data);
        }
      });
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
    check_browser: function () {
      let agent = navigator.userAgent.toLowerCase();
      let isiOSSafari = navigator.userAgent.match(/like Mac OS X/i)
        ? true
        : false;
      if (isiOSSafari) {
        if (agent.indexOf("safari") !== -1) {
          this.browser = "safari";
        }
      }
    },
    confirm() {
      if (this.sendData.title === "") {
        alert(this.$i18n.t("alert.common.title_required"));
        return false;
      }

      ax.setSwingTitleWrite(
        this.sendData.swingno,
        this.sendData.title,
        this.sendData.content,
        this.sendData.flag,
        (flag, data) => {
          if (flag) {
            this.getList();
            this.$refs["settingModal"].hide();
            this.sendData.swingno = 0;
            this.sendData.title = "";
            this.sendData.content = "";
            this.sendData.flag = 0;
          }
          alert(data.message);
        }
      );
    },
  },
  mounted() {
    this.check_browser();
  },
};
</script>

<style scoped>
.h-50px {
  height: 50px;
}
</style>
